import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { FieldLoader } from "./FieldLoader";

interface Props {
  label?: string;
  hint?: string;
  error?: string;
  optionalSuffix?: string;
  full?: boolean;
  /**
   * Sobrepone un spinner al campo mientras carga su catálogo o consulta (ver `FieldLoader`).
   * Pasarlo o no debe ser estático por call site: la discriminación es por `undefined`, para que la
   * estructura del árbol no cambie en runtime y el campo no se remonte (perdería el foco).
   */
  loading?: boolean;
  children: ReactNode;
}

export const FieldWrapper = ({ label, hint, error, optionalSuffix, full, loading, children }: Props) => (
  <Box sx={{ gridColumn: full ? "1 / -1" : undefined, display: "flex", flexDirection: "column", gap: 0.5 }}>
    {label && (
      <Typography variant="body2" fontWeight={500} color="primary.dark">
        {label}
        {optionalSuffix && (
          <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
            {optionalSuffix}
          </Typography>
        )}
      </Typography>
    )}
    {loading === undefined ? children : <FieldLoader loading={loading}>{children}</FieldLoader>}
    {error ? (
      <Typography variant="body2" color="error.main">
        {error}
      </Typography>
    ) : hint ? (
      <Typography variant="body2" color="text.secondary">
        {hint}
      </Typography>
    ) : null}
  </Box>
);

/**
 * `SelectProps` que oculta el chevron del desplegable mientras el campo carga su catálogo, para que
 * no se encime con el spinner de `loading`. Va en el `TextField`, no en el wrapper.
 */
// eslint-disable-next-line react-refresh/only-export-components -- helper del propio campo; conviene tenerlo junto al wrapper
export const selectLoadingProps = (loading: boolean) => (loading ? { IconComponent: () => null } : undefined);
